var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "div",
      [
        _c("SelectorSearch", {
          attrs: {
            "active-filters": _vm.activeFilters,
            query: _vm.query,
          },
          on: {
            search: _vm.onSearch,
            "update-active-filters": _vm.onUpdateActiveFilters,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.filteredStockImages, function (stockImage) {
        return _c(
          "li",
          {
            key: stockImage.id,
          },
          [
            _c("SelectableImageCard", {
              attrs: {
                "stock-image": stockImage,
              },
              nativeOn: {
                click: function click($event) {
                  return _vm.onSelectImage(stockImage)
                },
                keyup: function keyup($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onSelectImage(stockImage)
                },
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }